<template>
  <div id="app">
    <b-loading v-if="loading" :is-full-page="true" :active="loading"></b-loading>
    <section v-else-if="error" class="hero is-fullheight is-dark is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{ error }}</h1>
          <button @click="retry()" class="button is-light">RETRY</button>
        </div>
      </div>
    </section>
    <section v-else-if="!accepted" class="hero has-text-white is-fullheight is-bold">
      <div class="hero-body text-funky">
        <div class="container">
          <div class="content" style="font-size: 12px">
            <p class="text-centered" style="background-color: black; border-radius: 20px; padding: 20px; text-align: center; word-break: break-word">
              {{ $store.state.info.name }} Tambola is a skill based game considered by supreme court of India. {{ $store.state.info.name }}
              is completely legal (except in case of assam and odisha) and has been designed by strictly following the set of rules stated by indian
              governing law and jurisdiction. At the same time it is legally registered with the appropriate registration authorities.
            </p>
          </div>
          <!--   <div class="content">
            <h1 class="title has-text-white">DECLARATION</h1>
            <p class="text-centered">
             I declare that i am a citizen of India. I am not a domicile of state of assam / odisha / telengana. <br />
             I am 18+ years of age as of today. I am not an employee / director / partner of {{$store.state.info.name}}.
            </p>
          </div> -->
          <button
            @click="accept()"
            style="margin: auto; background-color: yellow;"
            class="button is-medium is-fullwidth is-outlined text-funky enter-btn"
          >
            ENTER
          </button>
        </div>
      </div>
    </section>
    <router-view v-else />
    <notifications group="global" />
  </div>
</template>

<script>
  import firebase from "firebase/app";
  import "firebase/auth";

  export default {
    data() {
      return {
        error: null,
        fetchingInfo: true,
        loading: true,
        accepted: false
      };
    },
    async created() {
      try {
        this.$store.dispatch("fetchInfo").then(() => {});
        let route = await this.$store.dispatch("fetchStatus");
        firebase.auth().onAuthStateChanged(async (user) => {
          this.loading = false;
          if (this.$route.name !== "Admin" && this.$route.name !== "Login") {
            this.$router.push(route);
          } else {
            if (user) {
              this.accept();
              this.$store.commit("SET_USER", user);
            }
          }
        });
      } catch (error) {
        //
        console.log(error);
        this.loading = false;
        this.error = "Something went Wrong!";
      }
    },
    methods: {
      retry() {
        window.location.href = "/";
      },
      accept() {
        this.accepted = true;
      }
    }
  };
</script>

<style>
  .green-background {
    background: #03134b !important;
  }
  .page-header {
    font-size: 30px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    font-weight: 700;
    color: #020004 !important;
  }
  #app {
    font-family: "Gill Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    word-break: break-word;
  }

  #app-loader {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .enter-btn {
    animation: glowing 1500ms infinite;
    border: 2px solid #870000;
    border-radius: 20px !important;
    color: #000 !important;
    font-size: 20px;
    font-weight: 700;
    text-wrap: wrap;
    padding: 10px;
    text-transform: uppercase;
  }

  @-webkit-keyframes glowing {
    0% {
      background-color: #f4cf28;
      box-shadow: 0 0 3px #f4cf28;
    }
    50% {
      background-color: #f49c28;
      box-shadow: 0 0 40px #f49c28;
    }
    100% {
      background-color: #f46928;
      box-shadow: 0 0 3px #f46928;
    }
  }

  @-moz-keyframes glowing {
    0% {
      background-color: #f4cf28;
      box-shadow: 0 0 3px #f4cf28;
    }
    50% {
      background-color: #f49c28;
      box-shadow: 0 0 40px #f49c28;
    }
    100% {
      background-color: #f46928;
      box-shadow: 0 0 3px #f46928;
    }
  }

  @-o-keyframes glowing {
    0% {
      background-color: #f4cf28;
      box-shadow: 0 0 3px #f4cf28;
    }
    50% {
      background-color: #f49c28;
      box-shadow: 0 0 40px #f49c28;
    }
    100% {
      background-color: #f46928;
      box-shadow: 0 0 3px #f46928;
    }
  }

  @keyframes glowing {
    0% {
      background-color: #f4cf28;
      box-shadow: 0 0 3px #f4cf28;
    }
    50% {
      background-color: #f49c28;
      box-shadow: 0 0 40px #f49c28;
    }
    100% {
      background-color: #f46928;
      box-shadow: 0 0 3px #f46928;
    }
  }
</style>
